import React from 'react';

interface ChangeLanguageFunctionInterface {
    (language: string): void;
}

interface Map {
    [key: string]: string;
}

interface LanguageContextInterface {
    changeLanguage: ChangeLanguageFunctionInterface | undefined;
    messages: Map;
}

export const LanguageContext: React.Context<LanguageContextInterface> =
    React.createContext<LanguageContextInterface>({
        changeLanguage: undefined,
        messages: {},
    });

export const Provider = LanguageContext.Provider;
